// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e464defe","404":"05c87ba7","498":"5da0413a","787":"10b81723"}[chunkId] + ".chunk.js";
};